import React, { useCallback, useEffect, useState } from 'react'
import Flights from './Flights'
import Packages from './Packages'
import Insights from './Insights'
import getDashboard from '../../controllers/dashboard/getDashboard';
import Overview from './Overview';
import Hotels from './Hotels';
import ActivityLogs from './ActivityLogs';
import { getNotifications } from '../../controllers/settings/notification/getNotifications';
import { NotificationsOutlined } from '@mui/icons-material';
import ModalLocal from '../../components/mini/ModalLocal';


let filterInit = {
  daily: {index: 0,days: 1,label: 'Daily'},
  weekly: {index: 1,days: 7,label: 'Weekly'},
  monthly: {index: 2,days: 30,label: '30 days'},
  quarterly: {index: 3,days: 360/4,label: 'Quarterly'},
  yearly: {index: 4,days: 360,label: 'Yearly'},
  all: {index: 5,days: 'All',label: 'All'},
}
function Index() {
  const [key,setKey] = useState(2);
  const [filter,setFilter] = useState(filterInit);
  const [data,setData] = useState();
  const [bookings,setBookings] = useState([]);
  const handleBookings = useCallback((data) => {
    setBookings(data)
  },[])
    useEffect(() => {
      try {
        load();
      } catch(ex) {}
    },[])
    async function load() {
      const res = await getDashboard();
      if(res.return) {
        setData(res.data)
        if(res.data.key) {
          setFilter(filt => {
            let temp = filt;
            temp.daily.index = res.data.key.daily;
            temp.weekly.index = res.data.key.weekly;
            temp.monthly.index = res.data.key.monthly;
            temp.quarterly.index = res.data.key.quarterly;
            temp.yearly.index = res.data.key.yearly;
            return temp;
          })
        }
      }
    }

  let tour = []
  let flight = []
  let hotel = []
  try {
    tour = data.tour[key]
    flight = data.flight[key]
    hotel = data.hotel[key]
  } catch(ex) {}

  // console.log('obj: ',data)
  return (
    <div className='p-4 flex flex-col px-4 w-full overflow-auto gap-4 bg-[#f3f3f3]'>
      <div className='flex gap-2 items-center'>
        <Notifications />
        <select className='text-primary/50 self-end p-2 px-4'
          defaultValue={key}
          onChange={(ev) => setKey(ev.target.value)}>
          {Object.entries(filter).map(([key,val],i) => (
            <option value={val.index} key={i}>{val.label}</option>
          ))}
        </select>
      </div>


      <Insights 
       returnData={(data) => handleBookings(data)}
       obj={data} filter={{key,setKey,filter}}  />
      <Overview bookings={bookings} />
      <Flights obj={flight} />
      <Hotels obj={hotel} />
      <Packages obj={tour} />
      <ActivityLogs limit={10} />
    </div>
  )
}

function Notifications() {
  const [data,setData] = useState([]);
  const [selected,setSelected] = useState({});
  const [open,setOpen] = useState(false);


  useEffect(() => {
    if(selected.title)
      setOpen(true)
  },[selected])
  useEffect(() => {
    load();
  },[])
  async function load() {
    const res = await getNotifications();
    if(res.return) {
      let data = res.data;
      setData(data);
    }
  }

  return (
    <div className='flex items-center gap-4 flex-1 min-w-0 overflow-hidden '>
      {data.length > 0 && (
        <div className='p-2 px-3 flex gap-3 items-center'>
          <NotificationsOutlined className='text-sm' />
          <span className='h-[25px] border-r border-primary/30'></span>
        </div>
      )}
      <div className='overflow-x-auto flex items-center gap-4 h-full flex-1 min-w-0 whitespace-nowrap'>
        {data.map((obj,i) => (
          <b className='bg-secondary text-[12px] text-[#444] shadow-md p-1 rounded-2xl px-4 cursor-pointer hover:shadow-lg transition-all hover:scale-105'
          key={i} onClick={() => setSelected(obj)}>{obj.title}
          </b>
        ))}
        <a
          href='https://protocol2.btmtravel.net/'
          target='_blank'
          rel='noopener noreferrer'
          className='bg-secondary text-[12px] font-bold text-[#444] shadow-md p-1 rounded-2xl px-4 whitespace-nowrap hover:shadow-lg transition-all hover:scale-105'
        >
          PROTOCOL
        </a>
      </div>
      <ModalLocal open={open} setOpen={setOpen}>
        <div className='flex flex-col bg-secondary rounded-md p-5 pt-10 items-center gap-4 relative'>
          <div className='btn_close' onClick={() => setOpen(false)}>X</div>
          <div className='flex flex-col gap-4 max-w-[500px]'>
            <h3>{selected.title}</h3>
            <p>{selected.body}</p>
          </div>
        </div>
      </ModalLocal>
    </div>
  )  
}

export default Index